var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileChecked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Files / File Check"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 22.5H10C6.22876 22.5 4.34315 22.5 3.17157 21.3284C2 20.1569 2 18.2712 2 14.5V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.23869 2.5 10.0298 2.5C10.6358 2.5 11.1214 2.5 11.53 2.51666C11.5166 2.59659 11.5095 2.67813 11.5092 2.76057L11.5 5.59497C11.4999 6.69207 11.4998 7.66164 11.6049 8.44316C11.7188 9.29028 11.9803 10.1373 12.6716 10.8285C13.3628 11.5198 14.2098 11.7813 15.0569 11.8952C15.8385 12.0003 16.808 12.0002 17.9051 12.0001L18 12.0001H21.9574C22 12.5344 22 13.1901 22 14.0629V14.5C22 18.2712 22 20.1569 20.8284 21.3284C19.6569 22.5 17.7712 22.5 14 22.5ZM10.4983 14.9394C10.8079 15.2146 10.8357 15.6887 10.5606 15.9983L7.89389 18.9983C7.75156 19.1584 7.54756 19.25 7.33333 19.25C7.11911 19.25 6.9151 19.1584 6.77278 18.9983L5.43944 17.4983C5.16425 17.1887 5.19214 16.7146 5.50173 16.4394C5.81131 16.1643 6.28537 16.1921 6.56056 16.5017L7.33333 17.3711L9.43944 15.0017C9.71463 14.6921 10.1887 14.6643 10.4983 14.9394Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3929 4.55375L19.3517 8.11665C20.5684 9.21164 21.2175 9.79588 21.5801 10.5001H18C15.643 10.5001 14.4645 10.5001 13.7322 9.76787C13 9.03564 13 7.85713 13 5.50011L13.0092 2.76562C13.7012 3.03114 14.2651 3.53868 15.3929 4.55375Z",
    fill: "#3B82F6"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileChecked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file_checked.ef2e85b0d1df265e35c1424fe9137655.svg";